import { IPage } from 'core/actions/admin/data';
import { ReportType } from 'core/slices/report';
import { ITextDAO, ITextSearchDAO } from './text';

export interface ISearch {
  term: string;
  sort?: SortBy | number;
  filter?: number;
  searchType?: SearchType;
  reportType?: ReportType;
  pagerInfo?: IPage;
  sessionId?: number;
  componentId?: string; // For tracking pagination state
}

export interface ISearchResponse {
  term: string;
  searchId: number;
  results: {
    list: ITextSearchDAO[];
    pagerInfo?: IPage;
  };
}

export enum SearchType {
  LEARNER = -1,
  COURSE = 0,
  MODULE = 1,
  VARIABLE = 2,
  CERTIFICATE = 3,
  GROUP = 4,
  ORG_USER = 5,
  REPORT_LATEST = 6,
  CERTIFICATES = 7,
  GROUPS = 8,
  SCENES = 9,
  COURSE_PROGRESS = 10,
}

export interface ISearchResult {
  orgUserId: number;
  moduleId: number;
  resourceId: number;
  courseProgressId: number;
  status: SearchResultStatus;
  duration: number;
  rating: number;
  tagId: number;
  place: number;
  total: number;
  searchId: number;
}

export enum SearchResultStatus {
  FAILED = -1,
  SUCCESS = 0,
}

export type SortOption = {
  name: string;
  value: SortBy | number;
};

export enum SortBy {
  NAME = 0,
  MODIFIED = 1,
  LEARNERS = 2,
  CERTIFICATES = 3,
  COMPLETIONS = 4,
  TOTAL = 5,
  CREATED = 6,
}
